<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3"></a>
<h1 class="title">THE GREAT CENTRAL RAILWAY</h1>
<p class="titlea">WHAT REALLY HAPPENED</p>
<p class="author">John Palmer</p>
<div class="img_containerp"><img alt="Image" src="images/pub.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?221c8f3a